import { render } from "./FooterBar.vue?vue&type=template&id=1b85c763&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=1b85c763&lang=scss&scoped=true"
import "./FooterBar.vue?vue&type=style&index=1&id=1b85c763&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b85c763"]])

export default __exports__